import { PersonalInfoActionTypes, PersonalInfoAction } from './personalInfoActionType';

const initialState = { setDob: localStorage.getItem('setDob') };

export function personalInfoReducer(state = initialState, action: PersonalInfoAction) {
    switch (action.type) {
        case PersonalInfoActionTypes.UPDATE_REQUEST:
            return {
                updating: true,
            };
        case PersonalInfoActionTypes.UPDATE_SUCCESS:
            return {
                updating: false,
                personalInfoUpdated: true,
            };
        case PersonalInfoActionTypes.DOB_SET:
            return {
                ...state,
                setDob: action.date,
            };
        case PersonalInfoActionTypes.UPDATE_FAILURE:
            return {
                ...state,
                updating: false,
            };
        default:
            return state;
    }
}
